import api from '../api';

export const announcementApi = api.injectEndpoints({
  endpoints: builder => ({
    getAnnouncements: builder.query({
      query: () => ({
        url: '/api/announcements/getall',
        method: 'GET'
      })
    })
  })
});

export const { useGetAnnouncementsQuery } = announcementApi;
